import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 8px;
`

export const PageTitle = styled.h1`
  font-size: 24px;
  padding: 6px 8px;
  margin-bottom: 8px;
  background-color: white;
`;
